import { render } from "./BitacorasList.vue?vue&type=template&id=1de50606&scoped=true"
import script from "./BitacorasList.vue?vue&type=script&lang=js"
export * from "./BitacorasList.vue?vue&type=script&lang=js"

import "./BitacorasList.vue?vue&type=style&index=0&id=1de50606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\Arenal\\ViajesControl\\Arenal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de50606"]])

export default __exports__